import { useEffect, useState } from "react"

import { CircularProgress } from "@mui/material"
import Stack from "@mui/material/Stack"
import { CCardGroup } from "@coreui/react"
import Button from "@mui/material/Button"
import { CModal, CModalHeader, CModalTitle, CModalBody } from "@coreui/react"

import SectionDivider from "../common/SectionDivider"
import UserPersonalData from "./UserPersonalData"
import UserEntrenosData from "./UserEntrenosData"
import UserTournamentsData from "./UserTournamentsData"
import UserEditForm from "./UserEditForm"

import { useUserAuth } from "../../firebase/UserAuthContext"
import { db } from "../../firebase/firebase_config"
import { getDocs, query, collection, where } from "firebase/firestore"
import UserHockeyData from "./UserHockeyData"

import "./Profile.css"

const Profile = () => {
	const { user } = useUserAuth()
	const [isDataReady, setDataReady] = useState(false)
	const [dbUser, setDbUser] = useState(null)
	const [modalVisiable, setModalVisible] = useState(false)

	const getUserData = async () => {
		setDataReady(false)
		try {
			const userCol = collection(db, "Users")
			const q = query(userCol, where("uid", "==", user.uid))
			const q_snapshot = await getDocs(q)
			//console.log(q_snapshot)
			if (q_snapshot.docChanges().length > 0) {
				//User already exists on DB
				q_snapshot.forEach((doc) => {
					//console.log("User exists doc id: " + doc.id)
					//console.log("User exists: " + doc.data().displayName)
					//console.log(doc.data())
					setDbUser(doc.data())
					setDataReady(true)
				})
			} else {
				alert("Current user not found on db! Try reloading again!")
			}
		} catch (error) {
			alert("Error retrieving user profile from firestore: ", error.message)
		}
	}

	const editButton_handler = () => {
		setModalVisible(true)
	}

	useEffect(() => {
		if (user.uid) {
			//if user is logged in
			getUserData()
		}
	}, [user])

	return (
		<div className="content">
			{isDataReady && (
				<Stack spacing={2}>
					<CCardGroup className="profile_group_cards">
						<UserPersonalData
							photoURL={user?.photoURL}
							displayName={dbUser?.displayName}
							email={dbUser?.email}
							role={dbUser?.role}
							last_login={dbUser?.last_login}
						></UserPersonalData>
						<UserHockeyData
							club={dbUser?.club}
							position={dbUser?.position}
							aletas={dbUser?.aletas}
							stick={dbUser?.stick}
						></UserHockeyData>
					</CCardGroup>
					<SectionDivider text="Estadísticas" />
					<CCardGroup className="profile_group_cards">
						<UserEntrenosData
							user={dbUser}
							num_entrenos={dbUser?.num_entrenos}
						></UserEntrenosData>
						<UserTournamentsData
							num_torneos={dbUser?.num_torneos}
						></UserTournamentsData>
					</CCardGroup>
					<Button variant="contained" onClick={editButton_handler}>
						Edit
					</Button>
				</Stack>
			)}
			{!isDataReady && <CircularProgress />}
			<CModal
				alignment="center"
				scrollable
				visible={modalVisiable}
				onClose={() => setModalVisible(false)}
			>
				<CModalHeader>
					<CModalTitle>Editar datos</CModalTitle>
				</CModalHeader>
				<CModalBody>
					<UserEditForm user={dbUser} />
				</CModalBody>
			</CModal>
		</div>
	)
}

export default Profile
